import { Routes } from '@angular/router';
import { FaqPageComponent } from './pages/faq/faq-page.component';
import { LandingPageComponent } from './pages/landing/landing-page.component';

export const routes: Routes = [
	{
		path: '',
		component: LandingPageComponent,
	},
	{
		path: 'faq',
		component: FaqPageComponent,
	},
	{
		path: '**',
		redirectTo: '',
	},
];
